/* esm.sh - applesauce-common@5.2.0/helpers/emoji */
export * from "/*applesauce-common@5.2.0/esnext/helpers/emoji.mjs";
